import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthed } from "@/lib/api";

export const RequireAdmin = ({ children }) => {
  if (!isAuthed()) return <Navigate to="/admin/login" replace />;
  return children;
};
